import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorCorporateEmployeeRegionSearch = () => {
  const corporateEmployeeRegionSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/corporate/employee-region/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])
  return { corporateEmployeeRegionSearch }
}

export default InteractorCorporateEmployeeRegionSearch
